// Verificador do "Entrar com Google" (mesma fórmula do PKCE, RFC 7636): o navegador que
// clica no botão guarda um valor aleatório no sessionStorage e manda ao backend só o
// desafio S256. O código de uso único devolvido pelo backend só vale junto com esse
// verificador — um código levado para outro navegador (CSRF de login) não serve.
const STORAGE_KEY = "medhub_google_verifier";

function base64url(bytes) {
  let binario = "";
  bytes.forEach((b) => {
    binario += String.fromCharCode(b);
  });
  return btoa(binario).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

// O verificador é ASCII (base64url), então charCode = byte — dispensa TextEncoder.
export async function challengeDoVerificador(verifier, cryptoImpl = window.crypto) {
  const bytes = Uint8Array.from(verifier, (c) => c.charCodeAt(0));
  const digest = await cryptoImpl.subtle.digest("SHA-256", bytes);
  return base64url(new Uint8Array(digest));
}

// Gera e guarda um verificador novo; devolve o desafio a mandar para o backend.
export async function iniciarVerificadorGoogle(cryptoImpl = window.crypto) {
  const verifier = base64url(cryptoImpl.getRandomValues(new Uint8Array(32)));
  const challenge = await challengeDoVerificador(verifier, cryptoImpl);
  sessionStorage.setItem(STORAGE_KEY, verifier);
  return challenge;
}

export function lerVerificadorGoogle() {
  return sessionStorage.getItem(STORAGE_KEY);
}

export function limparVerificadorGoogle() {
  sessionStorage.removeItem(STORAGE_KEY);
}
